<form class="summary-form form-white justify-content-center p-x-page " [formGroup]="sendFormGroup" id="summaryForm"> <!-- p-t-23-->
    <div class="d-flex form-container" #container>
        <mat-form-field appearance="standard" color="accent" class="m-r-name-field m-t-24 m-l-mobile">
            <mat-label class="input-label">{{'b2c.IDS_NAME' | translate }}</mat-label>
            <input matInput class="form-control" type="text" id="input-name" formControlName="name" placeholder="{{'b2c.IDS_NAME' | translate }}">
        </mat-form-field>

        <mat-form-field appearance="standard" color="accent" class="m-r-name-field m-l-mobile" >
            <mat-label class="input-label">{{'b2c.IDS_SURNAME' | translate }}</mat-label>
            <input matInput class="form-control" type="text" id="input-surname" formControlName="surname" placeholder="{{'b2c.IDS_SURNAME' | translate }}">
        </mat-form-field>

        <mat-form-field appearance="standard" color="accent" class="m-r-name-field m-l-mobile">
            <mat-label class="input-label">{{'b2c.IDS_EMAIL' | translate }}</mat-label>
            <input matInput class="form-control" type="text" id="input-email" formControlName="email" placeholder="{{'b2c.IDS_EMAIL' | translate }}">
        </mat-form-field>

        <mat-form-field appearance="standard" color="accent" class="m-r-name-field m-l-mobile">
            <mat-label class="input-label">{{'b2c.IDS_TELEPHONE' | translate }}</mat-label>
            <input matInput class="form-control" type="text" id="input-telephone" formControlName="telephone" placeholder="{{'b2c.IDS_TELEPHONE' | translate }}">
        </mat-form-field> 

        <mat-form-field appearance="standard" color="accent" class="m-r-name-field m-l-mobile">
            <mat-label class="input-label">{{'b2c.IDS_PROVINCE' | translate }}</mat-label>
            <input matInput class="form-control" type="text" id="input-province" formControlName="province" placeholder="{{'b2c.IDS_PROVINCE' | translate }}">
        </mat-form-field> 

        <mat-form-field appearance="standard" color="accent" class="m-r-name-field m-l-mobile">
            <mat-label class="input-label">{{'b2c.IDS_CITY' | translate }}</mat-label>
            <input matInput class="form-control" type="city" id="input-telephone" formControlName="city" placeholder="{{'b2c.IDS_CITY' | translate }}">
        </mat-form-field> 

        <mat-form-field appearance="standard" color="accent" class="m-r-name-field m-l-mobile">
            <mat-label class="input-label">{{'b2c.IDS_CAP' | translate }}</mat-label>
            <input matInput class="form-control" type="text" id="input-postalcode" formControlName="postalcode" placeholder="{{'b2c.IDS_CAP' | translate }}">
        </mat-form-field> 

        <mat-form-field appearance="standard" color="accent" class="m-r-name-field m-l-mobile">
            <mat-label class="input-label">{{'b2c.IDS_ADDRESS' | translate }}</mat-label>
            <input matInput class="form-control" type="text" id="input-address" formControlName="address" placeholder="{{'b2c.IDS_ADDRESS' | translate }}">
        </mat-form-field> 
    </div>
    <div class="message-container" >
        <p>
            <mat-form-field class="input-message" color="accent">
                <textarea matInput class="input-message form-control" formControlName="message" placeholder="{{'b2c.IDS_MESSAGE' | translate }}"></textarea>
            </mat-form-field>
            <!-- <mat-form-field appearance="standard" class="m-r-name-field m-l-mobile">
                <mat-label class="input-label">{{'b2c.IDS_MESSAGE' | translate }}</mat-label>
                <input matInput  type="text" id="input-message" formControlName="message" placeholder="{{'b2c.IDS_MESSAGE' | translate }}">
            </mat-form-field>  -->
        </p>
        <div class="m-b-checkbox">
            <span class="f-size">{{ "b2c.IDS_INSTALLER_CHK_TEXT" | translate }}</span>
            <div class="d-flex flex-row flex-nowrap align-items-center m-y-checkbox">
                <mat-checkbox
                    class="d-inline-block"
                    id="input-privacy"
                    formControlName="privacy"
                    color="accent"
                >
                </mat-checkbox>
                <span class="d-inline-block p-l-16 f-size">
                    {{ "b2c.IDS_PRIVACY_INSTALLER_CHK" | translate }}&nbsp;<a [routerLink]="" queryParamsHandling="preserve" class="accent" href="mailto:privacy@pec.bticino.it">privacy@pec.bticino.it</a>
                </span>
            </div>
            <div class="d-flex flex-row flex-nowrap align-items-center">
                <mat-checkbox
                    class="d-inline-block"
                    id="input-share"
                    formControlName="share"
                    color="accent"
                >
                </mat-checkbox>
                <span class="d-inline-block p-l-16 f-size">
                    {{ "b2c.IDS_SHARE_INSTALLER_CHK" | translate }}
                </span>
            </div>
        </div>
    </div>
</form>
